/* ============================================
   SUVENE — Wishlist Snackbar Cleanup
   Killt Inline-Styles + versteckt redundanten Header-Title
   ============================================ */

(function() {
  'use strict';

  function cleanupSnackbar(snackbar) {
    if (!snackbar || snackbar.dataset.suCleaned === 'true') return;
    snackbar.dataset.suCleaned = 'true';

    // 1. Kill Inline schwarz-Hintergrund auf CardHeader
    const cardHeader = snackbar.querySelector('.MuiCardHeader-root');
    if (cardHeader) {
      cardHeader.style.backgroundColor = '';
      cardHeader.style.background = '';
    }

    // 2. SnackbarContent-root: Inline padding/styles fixen
    const content = snackbar.querySelector('.MuiSnackbarContent-root');
    if (content) {
      content.style.padding = '0';
      content.style.minWidth = '0';
      content.style.width = '320px';
      content.style.maxWidth = '320px';
      content.style.flexGrow = '0';
    }

// 3. Header-Title umbenennen zu kompaktem Label
    const titleSpan = snackbar.querySelector('.MuiCardHeader-title .wishlist-hero-dyna-translate');
    if (titleSpan) {
      if (titleSpan.textContent.toLowerCase().includes('added')) {
        titleSpan.textContent = 'Added to wishlist';
      }
      else if (titleSpan.textContent.toLowerCase().includes('removed')) {
        titleSpan.textContent = 'Removed from wishlist';
      }
    }

// 4. "VIEW WISHLIST" Link-Styling angleichen an SIZECHART (Caps)
    const viewWishlistLink = snackbar.querySelector('.MuiCardActions-root a');
    if (viewWishlistLink) {
      // Caps via uppercase Transform
      viewWishlistLink.style.setProperty('font-size', '10px', 'important');
      viewWishlistLink.style.setProperty('font-family', 'Helvetica, Arial, sans-serif', 'important');
      viewWishlistLink.style.setProperty('font-weight', '400', 'important');
      viewWishlistLink.style.setProperty('letter-spacing', 'normal', 'important');
      viewWishlistLink.style.setProperty('text-transform', 'uppercase', 'important');
      viewWishlistLink.style.setProperty('text-decoration', 'underline', 'important');
      viewWishlistLink.style.setProperty('text-underline-offset', '0.3rem', 'important');
      viewWishlistLink.style.setProperty('color', '#000', 'important');
      viewWishlistLink.style.setProperty('cursor', 'pointer', 'important');
      
      // Innerer Span auch — wegen Material-UI Wrapper
      const innerSpan = viewWishlistLink.querySelector('span, .wishlist-hero-dyna-translate');
      if (innerSpan) {
        innerSpan.style.setProperty('font-size', '10px', 'important');
        innerSpan.style.setProperty('font-family', 'Helvetica, Arial, sans-serif', 'important');
        innerSpan.style.setProperty('font-weight', '400', 'important');
        innerSpan.style.setProperty('letter-spacing', 'normal', 'important');
        innerSpan.style.setProperty('text-transform', 'uppercase', 'important');
        innerSpan.style.setProperty('color', '#000', 'important');
      }
    }

    // 5. CardActions Container — Spacing nach unten + sauberes Layout
    const cardActions = snackbar.querySelector('.MuiCardActions-root');
    if (cardActions) {
      cardActions.style.setProperty('padding', '8px 16px 18px 16px', 'important');
      cardActions.style.setProperty('margin', '0', 'important');
    }
  }

  function watchSnackbars() {
    // Schau ob schon eine offene Snackbar existiert
    document.querySelectorAll('.MuiSnackbar-root').forEach(cleanupSnackbar);

    // Beobachte neue Snackbars (App rendert sie dynamisch ein)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;
          
          // Snackbar selbst
          if (node.classList && node.classList.contains('MuiSnackbar-root')) {
            cleanupSnackbar(node);
          }
          // Snackbar in einem Sub-Tree
          const innerSnackbars = node.querySelectorAll && node.querySelectorAll('.MuiSnackbar-root');
          if (innerSnackbars && innerSnackbars.length) {
            innerSnackbars.forEach(cleanupSnackbar);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSnackbars);
  } else {
    watchSnackbars();
  }
})();